/**
 * このブラウザの識別子（doc/AUTH.md §1）。
 *
 * ログインしていない人のテーマ作成は 1 日 3 回までで、その「同じ人」をこれで見る。
 * IP だけで数えると、会場や社内 LAN のように出口 IP がひとつのところで全員が止まるので、
 * ブラウザに置く識別子を第一にする（消されたら数え直しになるが、悪意のない多重利用は防げる）。
 *
 * ランダムな値で、こちらからは誰かを知る手がかりにならない。サーバも日付を混ぜたハッシュしか持たない。
 */
const KEY = 'gendan.clientId';

const random = (): string => {
  try {
    if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID().replace(/-/g, '');
  } catch { /* 下の保険に落ちる */ }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
};

/** localStorage が使えないブラウザ（プライベートモードなど）でも、この読み込みのあいだは同じ値を返す。 */
let memo: string | null = null;

export function clientId(): string {
  if (memo) return memo;
  try {
    const saved = window.localStorage.getItem(KEY);
    // サーバ側（lib/anon.ts）が受ける形に揃える。違う形なら作り直す
    if (saved && /^[A-Za-z0-9_-]{8,64}$/.test(saved)) {
      memo = saved;
      return saved;
    }
    memo = random();
    window.localStorage.setItem(KEY, memo);
    return memo;
  } catch {
    memo ??= random();
    return memo;
  }
}

/** テーマ作成のときだけ添えるヘッダ。 */
export const clientIdHeader = (): Record<string, string> => ({ 'x-gendan-client': clientId() });
